export default "__VITE_ASSET__CRWGEyW2__"